import {
  GET_QUERY_PREVIEW_REQUEST,
  GET_QUERY_PREVIEW_SUCCESS,
  GET_QUERY_PREVIEW_FAILURE,
} from '../../constants/action-types';

import { createUniqueInfoIds } from '../../operations/query';

const getInitialState = () => {
  return {
    isLoading: true,
    target_query: {},
    queryEntitiesInfos: {},
    error: false,
    conversationQueries: {},
  };
};

const initialState = getInitialState();

const queryPreview = (state = initialState, action) => {
  const types = {
    [GET_QUERY_PREVIEW_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_QUERY_PREVIEW_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      target_query: action.audience.metadata.target_query,
      base_query: action.audience.metadata.base_query,
      label: action.audience.label,
      audience_timeframe: action.audience.metadata.audience_timeframe,
      results_timeframe: action.audience.metadata.results_timeframe,
      query_type: action.audience.metadata.query_type,
      queryEntitiesInfos: {
        ...createUniqueInfoIds(action.queryEntitiesInfos || []),
      },
      conversationQueries: action.conversationQueries,
      status: action.audience.metadata.status,
      data_source: action.audience.metadata.data_source,
    }),
    [GET_QUERY_PREVIEW_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default queryPreview;
